export const pageType = {
  VIEW: "VIEW",
  WRITE: "WRITE",
};
